var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glyph",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 48,
    height: 41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 40
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    transform: "translate(173.17 129.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    transform: "translate(-156.638 -120.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    className: "cls-2",
    d: "M-132.123-103.872H-134.3a.544.544,0,0,1-.544-.544.544.544,0,0,1,.544-.544h2.178a.544.544,0,0,0,.543-.544V-118.56a.544.544,0,0,0-.543-.544h-17.408a.544.544,0,0,0-.543.544.544.544,0,0,1-.544.544.544.544,0,0,1-.544-.544,1.633,1.633,0,0,1,1.631-1.632h17.408a1.633,1.633,0,0,1,1.631,1.632V-105.5A1.633,1.633,0,0,1-132.123-103.872Z",
    transform: "translate(151.162 120.192)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    transform: "translate(-163.17 -113.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    className: "cls-2",
    d: "M-144.13-91.869h-17.407A1.635,1.635,0,0,1-163.17-93.5v-13.056a1.635,1.635,0,0,1,1.633-1.632h17.407a1.635,1.635,0,0,1,1.633,1.632V-93.5A1.634,1.634,0,0,1-144.13-91.869ZM-161.537-107.1a.545.545,0,0,0-.545.544V-93.5a.545.545,0,0,0,.545.544h17.407a.545.545,0,0,0,.545-.544v-13.056a.545.545,0,0,0-.545-.544Z",
    transform: "translate(163.17 108.189)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    transform: "translate(-163.17 -107.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    className: "cls-2",
    d: "M-162.626-88.572a.543.543,0,0,1-.385-.159.543.543,0,0,1,0-.769l6.53-6.527a.543.543,0,0,1,.769,0l5.438,5.439a.543.543,0,0,1,0,.769.543.543,0,0,1-.769,0l-5.053-5.055-6.145,6.143A.543.543,0,0,1-162.626-88.572Z",
    transform: "translate(163.17 96.187)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    transform: "translate(-158.816 -104.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    className: "cls-2",
    d: "M-139.391-86.748a.543.543,0,0,1-.385-.159l-3.967-3.967-3.967,3.967a.543.543,0,0,1-.385.159h-6.527a.544.544,0,0,1-.544-.544.544.544,0,0,1,.544-.544h6.3l4.193-4.193a.543.543,0,0,1,.769,0l4.352,4.352a.543.543,0,0,1,0,.769A.543.543,0,0,1-139.391-86.748Z",
    transform: "translate(155.166 92.188)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    transform: "translate(-152.294 -111.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    className: "cls-2",
    d: "M-140.454-98.746a2.725,2.725,0,0,1-2.722-2.721,2.724,2.724,0,0,1,2.722-2.72,2.723,2.723,0,0,1,2.72,2.72A2.724,2.724,0,0,1-140.454-98.746Zm0-4.353a1.635,1.635,0,0,0-1.634,1.632,1.636,1.636,0,0,0,1.634,1.633,1.635,1.635,0,0,0,1.632-1.633A1.634,1.634,0,0,0-140.454-103.1Z",
    transform: "translate(143.176 104.187)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    transform: "translate(-159.903 -116.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    className: "cls-2",
    d: "M-138.128-97.87H-140.3a.544.544,0,0,1-.544-.544.544.544,0,0,1,.544-.544h2.175a.545.545,0,0,0,.545-.544v-13.056a.545.545,0,0,0-.545-.544h-17.406a.545.545,0,0,0-.543.545.544.544,0,0,1-.544.544.544.544,0,0,1-.544-.544,1.634,1.634,0,0,1,1.631-1.633h17.406a1.635,1.635,0,0,1,1.633,1.632V-99.5A1.635,1.635,0,0,1-138.128-97.87Z",
    transform: "translate(157.164 114.19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesIcon);
export default __webpack_public_path__ + "static/media/files-icon.bf216618.svg";
export { ForwardRef as ReactComponent };